import React from 'react';

export default function NavigationWidget(props) {
	// console.log('NavigationWidget', props);
	return (
		<div className="NavigationWidget d-flex justify-content-start my-2">
			<div className="w-100 d-flex justify-content-start align-items-center p-4 rounded">
				<div className="icon-container d-inline">
					<i className={`${props.icon}`} aria-hidden="true" />
				</div>
				<span className="ml-3">{props.label}</span>
			</div>
		</div>
	);
}
